import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { NOTICE_PRODUCT_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

const OpenNoticeProductDetail = (props) => {
  const { text, noticeProductId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(noticeProductId)) {
    return '-';
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(NOTICE_PRODUCT_DETAIL_URL_PATH, noticeProductId)}
      target="_blank"
    />
  );
};

export default OpenNoticeProductDetail;
